import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {AssignedContentIcon} from '../../../../resources/icons'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    borderBottom: 'solid 1px #dbe3e6',
    minHeight: '60px',
    paddingLeft: '15px'
  },
  middle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  label: {
    paddingTop: '4px',
    marginLeft: '20px',
    fontSize: '14pt',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(15),
    },
  },
}))

export default function InfoBar ({context}) {

  const {quizAssignmentToReassign} = context
  const classes = useStyles()
  return (
    <Box className={classes.root}>
      <Box className={classes.middle}>
        <AssignedContentIcon fill="#4f576e" />
      </Box>
      <Box className={`${classes.middle} ${classes.label}`}>
        {quizAssignmentToReassign.title}
      </Box>
    </Box>
  )
}
